export enum SIDEBAR_KEYS_CONFIG {
  AUDITS = "2",
  AUDITS_OVERVIEW = "2a",
  INTERNAL_ADMIN_AUDIT_PROJECTS = "2c",
  RISK_MANAGER = "7",
  ACCOUNT_PERSONAL_INFO = "13",
  ADMIN_TOOLS = "15",
  INTERNAL_ADMIN_PROJECTS = "15d",
  INTERNAL_ADMIN_ORGANIZATIONS = "15e",
  INTERNAL_ADMIN_USERS = "15f",
  ORGANIZATION = "18",
}
